<header class="bg-dark sticky top-0 z-50 border-b border-light/10">
  <div class="container mx-auto px-4">
    <div class="flex items-center justify-between h-20">
      <div class="flex items-center">
        <a routerLink="/" class="text-xl font-bold text-light">Kansino Nederland</a>
      </div>
      
      <!-- Desktop Navigation -->
      <nav class="hidden md:flex items-center space-x-8 text-sm">
        <a routerLink="/about" routerLinkActive="text-primary font-semibold" class="hover:text-primary transition-all duration-300">Over Ons</a>
        <a routerLink="/contact" routerLinkActive="text-primary font-semibold" class="hover:text-primary transition-all duration-300">Contact</a>
        <a routerLink="/faq" routerLinkActive="text-primary font-semibold" class="hover:text-primary transition-all duration-300">FAQ</a>
        <a routerLink="/testimonials" routerLinkActive="text-primary font-semibold" class="hover:text-primary transition-all duration-300">Beoordelingen</a>
      </nav>

      <div class="hidden md:flex items-center">
        <div class="bg-primary/20 border border-primary px-4 py-2 rounded-md">
          <span class="text-primary font-bold text-lg">18+</span>
        </div>
      </div>

      <!-- Mobile Menu Button -->
      <button 
        *ngIf="isMobile"
        (click)="toggleMobileMenu()"
        class="md:hidden p-2 text-light"
        aria-label="Toggle menu"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path *ngIf="!mobileMenuOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
          <path *ngIf="mobileMenuOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- Mobile Navigation -->
    <nav *ngIf="isMobile && mobileMenuOpen" class="md:hidden pb-4 border-t mt-2 pt-4 border-light/10">
      <a routerLink="/about" (click)="toggleMobileMenu()" class="block py-2 hover:text-primary transition-colors">Over Ons</a>
      <a routerLink="/contact" (click)="toggleMobileMenu()" class="block py-2 hover:text-primary transition-colors">Contact</a>
      <a routerLink="/faq" (click)="toggleMobileMenu()" class="block py-2 hover:text-primary transition-colors">FAQ</a>
      <a routerLink="/testimonials" (click)="toggleMobileMenu()" class="block py-2 hover:text-primary transition-colors">Beoordelingen</a>
      <div class="mt-4 pt-4 border-t border-light/10">
        <div class="bg-primary/20 border border-primary px-4 py-2 rounded-md text-center">
          <span class="text-primary font-bold text-lg">18+</span>
        </div>
      </div>
    </nav>
  </div>
</header>

